import { useTranslation } from 'react-i18next';
import { timeAgo } from '../../utils/dateUtils';
import TablePagination from './TablePagination';

function ReportsTable({
  title,
  tint = 'rose',
  reports,
  showUser = true,
  showMessage = true,
  showResolveAction = false,
  onToggleResolve,
  onRowClick,
  emptyMessage,
  pagination,
  fullWidth = false,
}) {
  const { t } = useTranslation('admin');
  const columnCount = 1 + (showUser ? 1 : 0) + 1 + 1 + (showResolveAction ? 1 : 0);
  const resolvedEmptyMessage = emptyMessage ?? t('reportsTable.noReportsYet');

  return (
    <div className={`sheet-table-card${fullWidth ? ' sheet-table-card--full' : ''}`}>
      <div className={`sheet-panel-header tint-${tint}`}>
        <span>{title}</span>
      </div>
      <div className="table-scroll-x">
      <table className="sheet-table report-table" style={{ minWidth: '520px' }}>
        <thead>
          <tr>
            {showUser && <th>{t('reportsTable.user')}</th>}
            <th>{t('reportsTable.report')}</th>
            <th>{t('reportsTable.submitted')}</th>
            <th>{t('reportsTable.status')}</th>
            {showResolveAction && <th aria-label="Resolve" />}
          </tr>
        </thead>
        <tbody>
          {reports.length === 0 && (
            <tr className="sheet-empty-row"><td colSpan={columnCount}>{resolvedEmptyMessage}</td></tr>
          )}
          {reports.map((report) => (
            <tr
              key={report.id}
              className={onRowClick ? 'account-row-clickable' : undefined}
              onClick={onRowClick ? () => onRowClick(report) : undefined}
            >
              {showUser && <td className="account-username">{report.username || t('reportsTable.unknownUser')}</td>}
              <td>
                <div className="report-cell">
                  <span className="report-subject">{report.subject}</span>
                  {showMessage && <span className="report-message">{report.message}</span>}
                </div>
              </td>
              <td className="account-joined">{timeAgo(report.createdAt)}</td>
              <td><span className={`report-status-pill ${report.status}`}>{report.status === 'resolved' ? t('reportsTable.resolved') : t('reportsTable.open')}</span></td>
              {showResolveAction && (
                <td>
                  <label className="report-resolve-toggle" onClick={(event) => event.stopPropagation()}>
                    <input
                      type="checkbox"
                      checked={report.status === 'resolved'}
                      onChange={(event) => onToggleResolve(report, event.target.checked ? 'resolved' : 'open')}
                    />
                    {report.status === 'resolved' ? t('reportsTable.resolved') : t('reportsTable.markResolved')}
                  </label>
                </td>
              )}
            </tr>
          ))}
        </tbody>
      </table>
      </div>
      {pagination && <TablePagination page={pagination.page} totalPages={pagination.totalPages} onChange={pagination.onChange} />}
    </div>
  );
}

export default ReportsTable;
